import Vue from 'vue'
import moment from 'moment'

/**
 * 全局filters
 * */

// 金额小数0.00保留过滤器
Vue.filter('moneyFilter', function(val,yuan,percent) {
  if (val && parseFloat(val)){
    if(yuan && yuan===true && parseFloat(val)){
      val=parseFloat(val)/100
    }
    const f = Math.round(val * 100) / 100
    let s = f.toString()
    let rs = s.indexOf('.')
    if (rs < 0) {
      rs = s.length; s += '.'
    }
    while (s.length <= rs + 2) {
      s += '0'
    }
    if(percent){
      return s+percent
    }
    return s
  }else if(parseFloat(val)==0){
    if(percent){
      return '0.00'+percent
    }
    return '0.00'
  }else{
    return '0.00'
  }
})

// 日期格式化过滤器
Vue.filter('formatDate', function(value, formatString) {
  formatString = formatString || 'YYYY-MM-DD HH:mm:ss'
  if(value){
    return moment(value).format(formatString) // value可以是普通日期 20170723
  // return moment.unix(value).format(formatString); // 这是时间戳转时间
  }else{
    return ""
  }
  
})



// WEBPACK FOOTER //
// ./src/utils/filters.js